exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button {\n  float: right;\n}\n\n.spacer {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  width: 1px;\n  height: 1px;\n  float: right;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/payment/dowload-invoice/dowload-invoice.component.css
// module id = ../../../../../src/app/components/payment/dowload-invoice/dowload-invoice.component.css
// module chunks = main